import SearchContainer from '@/pages/search-syllabus'
export { getStaticProps } from './search-syllabus'

export default function BrowseSyllabus(props) {
	return (
		<SearchContainer
			{...props}
			searchBarPlaceholder="Search for syllabus"
			azureSearchOptions={{
				contentType: 'syllabus-overview',
				searchFields: 'title,keywords',
				orderby: 'title',
			}}
			defaultContentType="syllabus-overview"
			isUseWildcard
			hidePagination
			showTitleOnlyForResults
			redirectWhenIsNotInIframe="/learning-areas"
			includeQueryParamsWhenRedirectingWhenIsNotInIframe={false}
			resultsWrapperClassName="mt-[56px]"
			hideResultsBar
			preserveFiltersOnSearch
			enableSearchOnChange
			sortResultsAlphabetically
			onlyRefreshResult
		/>
	)
}
